export default "__VITE_ASSET__DavnzDtB__"